
import CommonSucessdemo from "@/components/common-sucessdemo.vue";
import { caseList } from "@/api/successCases";
export default {
  scrollToTop: true,

  components: {
    CommonSucessdemo,
  },
  head() {
    return {
      title: "巨得案例-商城源码",
      meta: [
        {
          name: "description",
          content:
            "成功案例栏目精选合作案例供大家参考，帮助开发者快速搭建个性化在线商城。所有商城源码均为开源源码，包含B2C商城、B2B2C商城、S2B2C商城、O2O商城、社区团购等多种商城源码",
        },
        {
          name: "keywords",
          content:
            "成功案例,商城源码,开源商城系统,在线商城,源码,小程序商城源码,B2C商城源码,B2B2C商城源码,JAVA商城源码,多商户商城源码,在线商城源码,社区团购源码,O2O商城源码,S2B2C商城源码,app商城源码",
        },
      ],
    };
  },
  async asyncData() {
    const query = "size/" + 10 + "/current/" + 1;
    const res = await caseList(query);
    return {
      arrs: res.data.data.records,
      total: res.data.data.total,
    };
  },
  data() {
    return {
      arrs: [],
      total: 0, //总条数
      params: {
        size: 10,
        current: 1,
      },
    };
  },
  methods: {
    handleSizeChange(val) {
      this.params.size = val;
      this.caseList();
    },
    handleCurrentChange(val) {
      this.params.current = val;
      this.caseList();
    },
    caseList() {
      const query =
        "size/" + this.params.size + "/current/" + this.params.current;
      caseList(query)
        .then((res) => {
          this.arrs = res.data.data.records;
          this.total = res.data.data.total;
        })
        .catch((err) => {});
    },
  },
  mounted() {
    this.caseList();
  },
};
